import { Link } from 'react-router-dom';
import { compromisoData } from '@/mocks/nosotros-data';

export default function CompromisoSection() {
  return (
    <section className="relative py-20 md:py-32 overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Emotional%20documentary%20photograph%20of%20diverse%20peruvian%20musicians%20standing%20together%20in%20unity%20at%20a%20cultural%20venue%20natural%20warm%20lighting%20genuine%20expressions%20of%20pride%20and%20solidarity%20authentic%20community%20gathering%20artistic%20atmosphere%20human%20connection%20through%20music%20cultural%20heritage%20celebration%20elegant%20editorial%20quality&width=1920&height=900&seq=soniem-nosotros-compromiso-bg&orientation=landscape"
          alt="Compromiso SONIEM con los artistas musicales"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/95 via-foreground-950/85 to-foreground-950/70" />
        <div className="absolute inset-0 bg-primary-900/15 mix-blend-multiply" />
      </div>

      {/* Content */}
      <div className="relative z-10 px-4 md:px-6 lg:px-10">
        <div className="max-w-3xl mx-auto text-center">
          <span className="inline-block text-xs md:text-sm font-semibold uppercase tracking-widest text-primary-400 mb-4">
            SONIEM
          </span>
          <h2 className="font-heading text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-6">
            {compromisoData.title}
          </h2>
          <p className="text-white/60 text-sm md:text-base max-w-xl mx-auto mb-10 leading-relaxed">
            {compromisoData.description}
          </p>

          {/* CTA Button */}
          <Link
            to={compromisoData.ctaHref}
            className="group inline-flex items-center gap-3 px-10 py-5 rounded-full bg-primary-500 text-white font-semibold text-sm md:text-base hover:bg-primary-600 transition-all duration-300 whitespace-nowrap"
          >
            <span>{compromisoData.ctaLabel}</span>
            <div className="w-8 h-8 rounded-full bg-white/20 flex items-center justify-center group-hover:translate-x-1 transition-transform">
              <i className="ri-arrow-right-up-line text-white text-sm" />
            </div>
          </Link>
        </div>
      </div>
    </section>
  );
}